/*
 * @Description: 
 * @version: 
 * @Author: guyifeng
 * @Date: 2020-09-27 15:05:46
 * @LastEditors: guyifeng
 * @LastEditTime: 2020-09-28 15:14:44
 */
import { setBaseURL, request, createAxios } from "./utils/request";
import { getQuery, confirmPlatfrom } from "./utils/url-params";
import { getCookie } from "./utils/cookie";
import { READIO_SERVER_HOST, SERVER, TEACHING_SERVER } from "./constants/servers";

// noinspection JSCheckFunctionSignatures
export const toTimeStamp = (time) =>
  time ? Date.parse(new Date(time)) : Date.now();

export function postMessageData(data, obj) {
  const { cc } = window;
  const courseId = cc && cc.course_id;
  // noinspection JSUnresolvedVariable
  const classId = getQuery().clazzOid || (cc && cc.package_id) || getQuery().package_id;
  const sys = data.ua;
  const platform = confirmPlatfrom();
  const postData = {
    message: "",
    lecture_id: data.lectureId || "",
    message_source: data.messageSource || "",
    course_id: data.courseId || courseId || "",
    clazz_id: classId || data.packageId || "",
    message_content_type: "text",
    msg_source: data.messageSource || "",
    platform,
    sys_version: sys.sysVersion, // 系统版本
    sys_name: sys.os,
    study_env: data.studyEnv,
    browser: sys.browser,
    project_url: data.projectUrl,
    labels: data.labels,
  };
  if (data.studyEnv !== "3.0") {
    Object.assign(postData, {
      project_data_log_id: data.projectDataLogId || "",
    });
  }
  return Object.assign(postData, obj);
}

export const ApiUri = {
  get CHECK() {
    return `${READIO_SERVER_HOST}/im/checks`;
  },
  get PROFILE() {
    return `${SERVER}/students/self/detail`;
  },
  get MARK_READ() {
    return `${READIO_SERVER_HOST}/im/mark-read`;
  },
  get OBTAIN_PROBLEMS() {
    return `${SERVER}/teaching-dialogue/faq/list`;
  },
  get MESSAGES() {
    return `${READIO_SERVER_HOST}/messages`;
  },
  get OBTAIN_ANSWER() {
    return `${SERVER}/teaching-dialogue/faq/obtain_answer`;
  },
  get OBTAIN_MARVIN() {
    return `${TEACHING_SERVER}/api/student/marvin`;
  },
};

export {
  setBaseURL,
  request,
  createAxios,
  getQuery,
  confirmPlatfrom,
  getCookie,
};
